/* eslint-disable import/prefer-default-export */
import { Button } from 'react-bootstrap';
import styled from 'styled-components';

export const StyledConfirmButton = styled(Button)`
    width: 200px;
`;
